import React, { Component, PropTypes } from 'react';
import { formatNumber, DateFormatter } from '../../utils/date';
import css from './relatedjobs.scss';
import { jobsRoute } from '../../routes/index';
import {Link} from 'react-router';
import translate from '../../utils/translate';
import Clamp from 'react-clamp';

import SweetScroll from 'sweet-scroll';

export default class RelatedJobs extends Component {
	static propTypes = {};
	constructor(props) {
		super(props);
	}

	render() {

		return (
			<section className='related-jobs span14'>
				<div className='related-jobs__left span5 span14-mobile'>
					<h2 className='related-jobs__title span9-mobile'>{this.props.title}</h2>
					<Link className='button related-jobs__all-jobs' to={jobsRoute()}>All jobs</Link>
				</div>
				{this.props.jobs.length && (
					<ul className='related-jobs__job-holder span9 span14-mobile'>
						{this.props.jobs.map((job, i) => this.renderJob(job, i))}
					</ul>
				) || (
					<ul className='related-jobs__job-holder span9 span14-mobile'>
						<li className='related-jobs__job related-jobs__job--sole span3 span9-tablet span14-mobile'>
							<h3 className='related-jobs__job__title hide-mobile'>No current job vacancies posted on FWA</h3>
							<a href='#contact' className='related-jobs__job__btn button' onClick={(event) => this.scroll(event)}>Get in touch</a>
						</li>
					</ul>
				)}
			</section>
		);
	}

	scroll(e) {
		e.preventDefault();
		const scroller = new SweetScroll({ easing: 'easeOutQuint', offset: -60, duration: 700 });
		scroller.to('#contact');
	}

	renderJob(job, i) {
		let createdDate = new DateFormatter(job.createdDate);
		let uid = job.uid || ('job' + job.id);
		let url = jobsRoute(job.slug);

		if (i < 3) {
			return (
				<li key={uid} className='related-jobs__job span3 span9-tablet span14-mobile'>
					{this.props.browser.window.width > 1199 && (
					<h3 className='related-jobs__job__title'>{job.title}</h3>
					) || (
					<h3 className='related-jobs__job__title'><Clamp clamp={1} ellipsis="…">{job.title}</Clamp></h3>
					)}
					<h4 className='related-jobs__job__city'>{job.city}, {job.country}</h4>
					<span className='related-jobs__job__added'>{'added: ' + createdDate.month + ', ' + createdDate.date + ' ' + createdDate.year}</span>
					<Link to={url} className='related-jobs__job__overlay'>
						<div className='button related-jobs__job__button'>Read more</div>
					</Link>
				</li>
			);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/relatedjobs/relatedjobs.js
 **/